import { path, pipe } from 'ramda';
import find from 'lodash/fp/find';
import reject from 'lodash/fp/reject';

export const getAll = path(['customers', 'marketingLeads', 'items']);

export const getAllWithoutNull = pipe(
  getAll,
  reject({ id: null }),
);

export const byId = (state, id) => pipe(
  getAll,
  find({ id }),
)(state);

const getUpdatedAt = path(['customers', 'marketingLeads', 'updatedAt']);
const TEN_MINUTES_IN_MILLISECONDS = 600000;
export const shouldFetchItems = pipe(
  getUpdatedAt,
  updatedAt => Date.now() - updatedAt > TEN_MINUTES_IN_MILLISECONDS,
);

export const getIsFetching = path(['customers', 'marketingLeads', 'isFetching']);
